import {
  AuthorizationField,
  credentialsFieldValueFormat,
} from "@redotech/http/semantics";
import { Currency } from "@redotech/money/currencies";
import { bearerCredentialsFormat } from "@redotech/oauth2/request";
import { TOKEN_KEY } from "@redotech/redo-merchant-app-common/auth";
import { REDO_API_URL } from "@redotech/redo-merchant-app-common/config";
import type { AxiosResponse } from "axios";
import axios, { AxiosHeaders } from "axios";

function widgetClient(widgetId: string) {
  const baseURL = `${REDO_API_URL}/widgets/${widgetId}`;
  const headers = new AxiosHeaders();
  return axios.create({ baseURL, headers });
}

const authentication = () => {
  const token = localStorage.getItem(TOKEN_KEY); // TODO(paul): defunct?
  if (!token) {
    return {};
  }
  return {
    [String(AuthorizationField.name)]: credentialsFieldValueFormat.write(
      bearerCredentialsFormat.write(token),
    ),
  };
};

export async function getCurrencyExchangeRatesMerchantAPI(
  widgetId: string,
  baseCurrency?: string,
): Promise<AxiosResponse<Record<Currency, number>>> {
  return widgetClient(widgetId).get<Record<Currency, number>>(
    "currency-conversion-rates",
    { params: { baseCurrency }, headers: authentication() },
  );
}
